import * as React from 'react';
import { isFunction } from 'swipeclock-frontend';
// https://www.joshwcomeau.com/snippets/javascript/debounce/
// Our debounce function takes two arguments: a callback function and a duration in milliseconds.
// Cancel any pre-existing timeouts
// Schedule a new timeout
// When the timeout expires, we call our callback function with apply, and feed it whatever arguments we have.
// This doesn't use the dreaded useEffect hook and reduces unnecessary renders
const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      // eslint-disable-next-line prefer-spread
      callback.apply(null, args);
    }, wait);
  };
};

export function useDebounce(callback, delayTime = 250) {
  const handleDebounce = React.useMemo(
    () =>
      debounce((ev) => {
        if (isFunction(callback)) {
          callback(ev);
        }
      }, delayTime),
    []
  );

  return handleDebounce;
}
